import cbbtc from './cbbtc.svg'
import cle from './cle.svg'
import dai from './dai.svg'
import eth from './eth.svg'
import ethereum from './ethereum.svg'
import ezeth from './ezeth.svg'
import gno from './gno.svg'
import lbtc from './lbtc.svg'
import pyusd from './pyusd.svg'
import red from './red.svg'
import reth from './reth.svg'
import rseth from './rseth.svg'
import sdai from './sdai.svg'
import sky from './sky.svg'
import speth from './speth.svg'
import spk from './spk.svg'
import sppyusd from './sppyusd.svg'
import spusdc from './spusdc.svg'
import spusdt from './spusdt.svg'
import stusds from './stusds.svg'
import susdc from './susdc.svg'
import susds from './susds.svg'
import tbtc from './tbtc.svg'
import usdc from './usdc.svg'
import usds from './usds.svg'
import usdt from './usdt.svg'
import wbtc from './wbtc.svg'
import weeth from './weeth.svg'
import weth from './weth.svg'
import wsteth from './wsteth.svg'

export const tokenLogos = {
  cle,
  dai,
  usdc,
  sdai,
  usds,
  susds,
  susdc,
  sky,
  spk,
  usdt,
  weth,
  eth,
  pyusd,
  stusds,
  spusdc,
  spusdt,
  speth,
  sppyusd,
  wbtc,
  wsteth,
  reth,
  weeth,
  cbbtc,
  lbtc,
  tbtc,
  ezeth,
  rseth,
  gno,
  red,
}

export const chainLogo = ethereum
